import { render } from "./DockingModal.vue?vue&type=template&id=b332254a&scoped=true"
import script from "./DockingModal.vue?vue&type=script&lang=js"
export * from "./DockingModal.vue?vue&type=script&lang=js"

import "./DockingModal.vue?vue&type=style&index=0&id=b332254a&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b332254a"]])

export default __exports__